import { forwardRef, MouseEvent, ReactElement, Ref } from "react";
import { Anchor } from "@twilio-paste/core/anchor";
import { Text } from "@twilio-paste/core/text";

import { types } from "./definitions";

const TrackingAnchor = forwardRef(
  (
    {
      children,
      noUnderline,
      onClick,
      trackEvent,
      ...rest
    }: types.TrackingAnchorProps,
    ref: Ref<HTMLAnchorElement>
  ): ReactElement => {
    const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
      if (trackEvent) {
        trackEvent();
      }

      if (onClick) {
        onClick(event);
      }
    };

    // Tricky: there's no way to remove the underline from Anchor, not even with className - only option that worked was to use <Text/> as "a"
    if (noUnderline) {
      return (
        <Text
          as="a"
          color="colorTextLink"
          onClick={handleClick}
          ref={ref}
          textDecoration="none"
          {...rest}
        >
          {children}
        </Text>
      );
    }

    return (
      <Anchor onClick={handleClick} ref={ref} {...rest}>
        {children}
      </Anchor>
    );
  }
);

export default TrackingAnchor;
